import { useMemo } from "react";
import { useShareableEntities } from "@/lib/api/shareable-entities";
import { toHistoryEntries, type HistoryEntry } from "./history-model";

export interface UseHistoryEntriesResult {
  entries: HistoryEntry[];
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
}

export function useHistoryEntries(
  menteeId: string | null,
): UseHistoryEntriesResult {
  const {
    data,
    isLoading,
    isError,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useShareableEntities(menteeId ?? undefined, "all", "all");

  const rawEntities = useMemo(
    () => data?.pages.flatMap((page) => page.entities) ?? [],
    [data],
  );

  const entries = useMemo(() => toHistoryEntries(rawEntities), [rawEntities]);

  return {
    entries,
    isLoading: menteeId === null || isLoading,
    isError,
    refetch: () => void refetch(),
    fetchNextPage: () => void fetchNextPage(),
    hasNextPage: Boolean(hasNextPage),
    isFetchingNextPage,
  };
}
